module.exports = {
	"next": "다음",
	"skip": "건너띄기",
	"cancel": "취소",
	"back": "뒤로",
	"sign up": "클라우드 생성",
	"add email": "이메일 주소 추가",
	"welcome": "환영합니다!",
	"confirm": "확인",
	"step preset": "설정",
	"step import": "데이터 가져오기",
	"step email settings": "이메일 설정",
	"preset email": "이메일",
	"preset email tip": "비밀번호 분실시 이 이메일 주소를 사용합니다.",
	"preset name": "이름",
	"preset name tip": "파일을 공유하거 이벤트 초대시 사용 됩니다.",
	"preset password": "비밀번호",
	"preset password tip": "최소 8자 이상이어야 합니다(특수문자 권장).",
	"preset timezone": "시간대",
	"preset timezone tip": "캘린더 표시시 정확한 시간을 표시 하는데 필요 합니다.",
	"preset opt-in help": "클라우드 향상을 위해 시스템 내용을 사용하도록 허용 합니다.",
	"preset opt-out newsletter": "Cozy 뉴스레터(권장).",
	"import from google": "구글 계정에서 데이터 가져오기",
	"import google account": "G메일 계정과 캘린더, 주소록, 사진을 동기화 합니다.",
	"import google account tip": "클라우드가 구글 계정에 접근 하도록 허용합니다.",
	"leave google title": "Cozy로 데이터를 제공 합니다",
	"leave google help me": "지원 요청!",
	"leave google sign in content": "클라우드가 구글 계정에 접근 하도록 허용합니다.",
	"leave google sign in": "구글 로그인",
	"leave google code content": "팝업 창에서 복사한 코드를 여기에 붙여 넣으세요:",
	"leave google code": "구글 코드",
	"leave google url doc": "https://docs.cozy.io/en/mobile/import-google.html",
	"leave google choice": "구글 서버에 저장된 데이터 중 필요한 것을 선택:",
	"leave google choice sync gmail": "GMail - 클라우드 접근 하도록 허용",
	"leave google choice contacts": "한번만 주소록 가져오기",
	"leave google choice calendar": "한번만 캘린더 가져오기",
	"leave google choice photos": "한번만 구글 사진 가져오기",
	"leave google confirm": "가져오기",
	"import error": "데이터를 가져오는 중 오류가 발생 하였습니다. 잠시 후에 다시 시도해 주세요.",
	"login welcome": "환영합니다. %{username}",
	"login enter your password": "클라우드에 접속 하기 위해 비밀 번호를 입력하세요:",
	"login password": "비밀번호",
	"login submit": "로그인",
	"login auth success": "인증 성공!",
	"login recover": "비밀번호를 잊어 버렸나요? 이메일을 보내주세요.",
	"login recover again": "이메일을 받지 못하셨나요? 다시 보내시겠습니까?",
	"login recover sent title": "이메일 보냄",
	"login recover sent message": "이메일을 확인해 주세요. 비밀번호를 초기화 하기 위하여 다음 단계를 실행 하세요.",
	"login recover error title": "이메일을 보내는 중에 오류가 발생했습니다.",
	"login recover error message": "이메일을 통해 비밀번호를 보내는중에 오류가 발생 하였습니다. 메 일 서버 또는 관리자에게 문의하세요.",
	"login wrong password title": "비밀번호가 틀립니다.",
	"login wrong password message": "입력된 비밀번호가 올바르지 않습니다. 다시 입력해 주세요.",
	"reset welcome": "비밀번호 초기화",
	"reset enter your password": "초기화 하기 위해 새 비빌번호를 입력하세요.",
	"reset password": "비밀번호",
	"reset submit": "비밀번호 초기화",
	"reset auth success": "비밀번호가 초기화 되었습니다.",
	"reset wrong password title": "비밀번호를 초기화 하지 못했습니다.",
	"reset wrong password message": "입력된 비밀번호가 올바르지 않거나, 사용기한이 종료 되었습니다.",
	"setup title": "클라우드를 설정 중입니다…",
	"setup message": "설정이 거의 완료 되었습니다.",
	"setup on mobile title": "안드로이드 장치에서 클라우드를 경험해 보세요!",
	"setup on mobile message": "구글 플레이에서 모바일 앱 설치:",
	"welcome title": "Congratulations on taking back control of your personal data!",
	"welcome message": "You can now store your data on your own personal cloud. As opposed to most cloud services, there is no data-mining taking place on your Cozy."
};


/*****************
 ** WEBPACK FOOTER
 ** ./app/locales/ko.json
 ** module id = 33
 ** module chunks = 1
 **/